export const CUSTOMER = 'customer';
export const LOGIN = 'login';
export const LOGIN_DONE = 'LOGIN_DONE';
export const AGENT = 'agent';
export const CSC = 'csc';
export const LIGHT = 'light';
export const DARK = 'dark';
export const LEFT = 'left';
export const RIGHT = 'right';
export const CENTER = 'center';
export const ROBOT = 'robot';
export const BUBBLE_MESSAGE = 'bubble_message';
export const BUBBLE_LOGIN_REQUEST = 'bubble_login_request';
export const STATUS_MESSAGE = 'status_message';
export const IMAGE = 'image';
export const BUBBLE_TYPES = [BUBBLE_MESSAGE, BUBBLE_LOGIN_REQUEST];
export const STATUS_TYPES = [STATUS_MESSAGE];
export const SHOW_CSC_EVENT = 'SHOW_CSC_EVENT';
export const DESKTOP = 'desktop';
export const DESKTOP_MOD = ' -desktop';
export const MOBILE = 'mobile';
export const MOBILE_MOD = ' -mobile';
export const AGENT_MOD = ' -agent';
export const ROBOT_MOD = ' -robot';
export const ACTIVED_MOD = ' -actived';
export const BLOCKED_MOD = ' -blocked';
export const CARD_TYPES = {
  ROBOT: 'robot',
  ROBOT_LIVEAGENT: 'robot_liveagent',
};



// WEBPACK FOOTER //
// ./src/const/objects.const.js